import { render } from "./ShowBudget.vue?vue&type=template&id=2071ef8b&scoped=true"
import script from "./ShowBudget.vue?vue&type=script&lang=js"
export * from "./ShowBudget.vue?vue&type=script&lang=js"

import "./ShowBudget.vue?vue&type=style&index=0&id=2071ef8b&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\projetos\\orcamento-online-concreto\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2071ef8b"]])

export default __exports__